module.exports = __webpack_public_path__ + "media/images/front/icons/arrow-left-blue-a15031f3177b4f4f8f99070bd8ea7b39.svg";